import React, { Component } from 'react';
import {Auth, API} from 'aws-amplify';
import AWS from 'aws-sdk';
import './iamExUsers.css';
import IamExUsTitleBar from './iamExUsTitleBar/iamExUsTitleBar.js';
import IamExUsContent from './iamExUsContent/iamExUsContent.js';
import {readableDate, paramParse} from '../../../universal/utils/index.js';

class IamExUsers extends Component {

  state = {
    iamAuditUsers: [],
    chosenUserId: '',
    serviceFilter: '',
    updateDate: '...',
    events: [],
    nexttoken: null
  };

    iamAuditUpdateInProgress = false;

    componentDidMount() {

      const parameters = paramParse(this.props.location.search);

      console.log(this.props.location.search);
      console.log(paramParse(this.props.location.search));

      setTimeout(() => {
        Auth.currentCredentials()
        .then(credentials => {
          this.S3 = new AWS.S3({credentials: Auth.essentialCredentials(credentials)});
          return this.downloadIamAudit();
        })
        .catch(err => {
          console.log(err);
        });
      }, 0);

      this.setState({chosenUserId: parameters.userid, serviceFilter: parameters.service});

    };

    downloadIamAudit = () => {

      return this.S3.getObject({Bucket: 'weaveability-basis-utilities-storage', Key: 'iamAudit/iamAudit.json', IfModifiedSince: new Date(2000)}).promise()
      .then(res => {
        const updateDate = readableDate(res.LastModified);
        this.setState({iamAuditUsers: JSON.parse(res.Body.toString()).Users, updateDate});
      });

    };

    refreshIamInformation = () => {

      let lambda;

      Auth.currentCredentials()
      .then(credentials => {
        lambda = new AWS.Lambda({credentials: Auth.essentialCredentials(credentials), region: 'eu-west-1'});
        this.iamAuditUpdateInProgress = true;
        const alias = process.env.REACT_APP_STAGE === 'development' ? 'Dev' : 'Prod';
        return lambda.invoke({FunctionName: 'iam-audit-updater', Qualifier: alias}).promise();
      })
      .then(res => {
        this.iamAuditUpdateInProgress = false;
        if (res.Payload === '"COMPLETE"') {
          return this.downloadIamAudit();
        }
      })
      .catch(err => {
        this.iamAuditUpdateInProgress = false;
        console.log(err);
      });

    }

    render() {

      const chosenUser = this.state.iamAuditUsers.find(user => user.UserId === this.state.chosenUserId);

      return (
        <div className="IamExUsersPage">
          <IamExUsTitleBar
            users={this.state.iamAuditUsers}
            selectUser={this.selectUser}
            filterActions={this.filterActions}
            updateDate={this.state.updateDate}
            refreshIamInformation={this.refreshIamInformation}
          />
          {
            chosenUser &&
            chosenUser.UserName &&
            <IamExUsContent
              user={chosenUser}
              serviceFilter={this.state.serviceFilter}
              refreshIamInformation={this.refreshIamInformation}
              events={this.state.events}
              downloadEvents={this.downloadEvents}
              nexttoken={this.state.nexttoken}
            />
          }
        </div>
      );

    };

    selectUser = userId => {
      this.setState({
        chosenUserId: userId,
        events: [],
        nexttoken: null
      });
    };

    filterActions = service => {
      this.setState({serviceFilter: service});
    };

    downloadEvents = () => {

      if (this.state.nexttoken !== 'FINISHED') {

        const chosenUser = this.state.iamAuditUsers.find(user => user.UserId === this.state.chosenUserId);

        return API.get('WBU', '/userevents', {
          queryStringParameters: {
            username: chosenUser.UserName,
            account: chosenUser.AccountId,
            nexttoken: this.state.nexttoken
          }
        })
        .then(res => {
          this.setState({
            events: [...this.state.events, ...res.events],
            nexttoken: res.nexttoken
          });

          if (!res.nexttoken) this.setState({nexttoken: 'FINISHED'});

        })
        .catch(err => {
          console.log(err);
        });

      }

    }

};

export default IamExUsers;


// WEBPACK FOOTER //
// ./src/components/content/iamExplorer/iamExUsers/iamExUsers.js